export default __webpack_public_path__ + "static/media/img1.7b78f5c3.svg";